import { Box, Stack, useTheme } from '@mui/material';
import ArticleIntro from './ArticleIntro';

export default function Article({ article }) {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        height: '341px',
        background: '#ffffff',
        borderRadius: '8px',
        overflow: 'hidden',
        display: 'flex',
        //justifyContent: 'center',
        //alignContent: 'center',
        position: 'relative',
        [theme.breakpoints.up('sm')]: {
          '& img': {
            height: '100%'
          }
        },
        [theme.breakpoints.down('sm')]: {
          //height: '154px',
          '& img': {
            width: '100%'
          }
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '16px',
          maxHeight: '70%'
        }}
      >
        <img src={article.image} />
      </Box>
      <ArticleIntro article={article} />
    </Stack>
  );
}
